import templates from '/app/templates'
import balanceText from './utils/balance-text'

export default class QuickReplies {
  constructor({ quickReplayHeaderText, widgetContainer, onChannelSelected }) {
    this.texts = {
      quickReplayHeaderText,
    }
    this.widgetContainer = widgetContainer

    this.isActive = true

    this.styleNamespace = 'cce-widget__quick-replies'
    this.$element = document.createElement('div')
    this.$element.className = this.styleNamespace
    this.onChannelSelected = onChannelSelected
  }

  setActive(flag) {
    this.isActive = flag
  }

  open() {
    this.toggleState('open', true)
  }

  close() {
    this.toggleState('open', false)
  }

  render() {
    this.$element.innerHTML = templates.quickReplies(this.getTemplateVariables())
    this.observeEvents()
  }

  getTemplateVariables() {
    return {
      h: { balanceText },
      texts: {
        quickReplayHeaderText: this.texts.quickReplayHeaderText,
      },
    }
  }

  toggleState(state, force = false) {
    this.$element.classList.toggle(`${this.styleNamespace}--${state}`, force)
    this.state = state
  }

  observeEvents() {}
}
